import React, { useState, useEffect } from "react";
import PageTitle from "../../layout/PageTitle";
import { toast } from "react-toastify";
import { sendEmail } from "../../utils/SendEmail";
import { validatePhoneNumber } from "../../utils/common";

function ContactUs({ setTab }) {
  const intialData = {
    name: "",
    phone: "",
    email: "",
    city: "",
    subject: "",
    message: "",
  };
  const [formData, setFormData] = useState(intialData);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { phone } = formData;

    // Validate the phone number
    if (!validatePhoneNumber(phone)) {
      toast.error("Please enter a valid phone number!");
    } else {
      sendEmail(
        formData,
        setFormData,
        intialData,
        "Message sent successfully!",
        3000,
        process.env.REACT_APP_EMAIL_JS_QUERY_TEMPLATE_ID
      );
    }
  };

  useEffect(() => {
    setTab("contactus");
  }, [setTab]);

  return (
    <>
      <PageTitle page="Contact Us" setTab={setTab} />
      <div className="site-main">
        <section className="ttm-row conatact-section clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <div className="padding_right30 res-991-padding_right0 res-991-margin_bottom50">
                  <div className="section-title">
                    <div className="title-header">
                      <h3>Touch In</h3>
                      <h2 className="title">
                        Have queries before the appointment?
                      </h2>
                    </div>
                    <div className="heading-seperator">
                      <span></span>
                    </div>
                  </div>
                  <div className="featured-icon-box icon-align-before-content style11">
                    <div className="featured-icon padding_right10">
                      <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                        <i className="fs-40 flaticon-email"></i>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h3 className="font-weight-500">Let's Talk</h3>
                      </div>
                      <div className="featured-desc">
                        <strong>Phone:</strong>
                        <a href="tel:7970479666"> +91 7970479666</a>
                        <br />
                        <strong>Email:</strong>
                        <a href="mailto:prasadeyehospital021@gmail.com">
                          {" "}
                          prasadeyehospital021@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="ttm-horizontal_sep width-100 margin_top25 margin_bottom25"></div>
                  <div className="featured-icon-box icon-align-before-content style11">
                    <div className="featured-icon padding_right10">
                      <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                        <i className="fs-40 flaticon-phone-call"></i>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h3 className="font-weight-500">Our Timing</h3>
                      </div>
                      <div className="featured-desc">
                        <strong>Monday - Sunday</strong>
                        <br />
                        10:00 AM to 06:00 PM
                      </div>
                    </div>
                  </div>
                  <div className="ttm-horizontal_sep width-100 margin_top25 margin_bottom25"></div>
                  <div className="featured-icon-box icon-align-before-content style11 margin_bottom0">
                    <div className="featured-icon padding_right10">
                      <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                        <i className="fs-40 flaticon-location"></i>
                      </div>
                    </div>
                    <div className="featured-content">
                      <div className="featured-title">
                        <h3 className="font-weight-500">Our Address</h3>
                      </div>
                      <div className="featured-desc">
                        Thana Chowk <br />
                        Ramgarh - 829122, Jharkhand, India
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="ttm-bgcolor-grey text-center p-40 padding_top35 res-991-p-15 res-991-padding_top30 res-991-padding_bottom30">
                  <h2 className="fs-26">Write Your Queries</h2>
                  <p>
                    Please enter your queries, and our representative will get
                    in touch with you.
                  </p>
                  <div className="padding_top30">
                    <div
                      id="request_qoute_form"
                      className="request_qoute_form wrap-form clearfix"
                      onSubmit={handleSubmit}
                    >
                      <div className="row ttm-boxes-spacing-20px">
                        <div className="col-md-6">
                          <label>
                            <span className="text-input">
                              <input
                                name="name"
                                type="text"
                                value={formData.name}
                                placeholder="Your Name*"
                                required="required"
                                onChange={handleInputChange}
                              />
                            </span>
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label>
                            <span className="text-input">
                              <input
                                name="phone"
                                type="number"
                                value={formData.phone}
                                placeholder="Phone Number*"
                                required="required"
                                onChange={handleInputChange}
                              />
                            </span>
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label>
                            <span className="text-input">
                              <input
                                name="email"
                                type="email"
                                value={formData.email}
                                placeholder="Your Email"
                                onChange={handleInputChange}
                              />
                            </span>
                          </label>
                        </div>
                        <div className="col-md-6">
                          <label>
                            <span className="text-input">
                              <input
                                name="city"
                                type="text"
                                value={formData.city}
                                placeholder="Your City"
                                onChange={handleInputChange}
                              />
                            </span>
                          </label>
                        </div>
                        <div className="col-md-12">
                          <label>
                            <span className="text-input">
                              <input
                                name="subject"
                                type="text"
                                value={formData.subject}
                                placeholder="Subject*"
                                required="required"
                                onChange={handleInputChange}
                              />
                            </span>
                          </label>
                        </div>
                        <div className="col-md-12">
                          <label>
                            <span className="text-input">
                              <textarea
                                name="message"
                                rows="4"
                                placeholder="Message*"
                                required="required"
                                value={formData.message}
                                onChange={handleInputChange}
                              ></textarea>
                            </span>
                          </label>
                        </div>
                        <div className="col-lg-12">
                          <div className="pt-15 mb_20 text-center">
                            <button
                              className="submit ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-dark w-100"
                              onClick={handleSubmit}
                            >
                              Send A Message!
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div id="google_map" className="google_map">
          <div className="map_container">
            <div id="map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3655.063448346651!2d85.50959157416804!3d23.637898693088278!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f4f328f6da8ea5%3A0xb6c47f47e6f9ff51!2sPrasad%20Eye%20Hospital!5e0!3m2!1sen!2sin!4v1736790739775!5m2!1sen!2sin"
                height="400"
                // style={{ border: 0 }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Prasad Eye Hospital"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactUs;
